<template>
    <div class="mask-container"  v-show="maskType">
        <div class="mask" @click="closeMask"></div>
        <div class="frame" v-if="maskType === 'joinTeam' || maskType === 'joinTeamFail1' || maskType === 'joinTeamFail2' || maskType === 'success' || maskType === 'failMessage'">
            <div class="in-circle in-top"></div>
            <div class="in-circle in-right"></div>
            <div class="in-circle in-bottom"></div>
            <div class="in-circle in-left"></div>
            <div class="border-upright"></div>
            <div class="border-across"></div>
            <div class="real-content" v-show="maskType === 'joinTeam'">
                <div class="model-title">请输入队伍编号</div>
                <input v-model="teamCode" class="custom-input" type="number">
                <div v-if="autoInput" class="auto-input-tip">
                    <span>自动检测到队伍邀请，点击可直接加入</span>
                </div>
                <img v-if="!autoInput" @click="teamSkinTeamJoin" class="btn-join" src="~assets/teamDraw/btn-join.png" alt="">
                <img v-if="autoInput" @click="teamSkinTeamJoin" class="btn-join" src="~assets/teamDraw/btn-join-now.png" alt="" style="margin-top:0.26rem">
            </div>
            <div class="real-content" v-show="maskType === 'joinTeamFail1' || maskType === 'joinTeamFail2'">
                <div class="model-title">加入队伍失败</div>
                <div class="model-text">很抱歉，你要加入的队伍已经{{maskType === 'joinTeamFail1' ? '解散' : '满员'}}，你可以自己发起 组队参加活动。</div>
                <img class="btn-join" @click="getTeamSkinTeamCreate" src="~assets/teamDraw/btn-open-team.png" alt="">
            </div>
            <div class="real-content" v-show="maskType === 'success'">
                <img @click="closeMask" class="btn-active icon-close" src="~assets/teamDraw/icon-close.png" alt="">
                <div class="model-title">成功发起组队</div>
                <div class="team-code">
                    <span>
                        队伍编号：{{successCode}}
                        <img class="copyName" @click="copyGiftCode(successCode)" src="~assets/teamDraw/icon-copy.png" alt="">
                    </span>
                </div>
                <div class="out-line-box">
                    <img class="line" src="~assets/teamDraw/line.png" alt="">
                    <div class="in-line-box"><span>通过以下方式邀请好友加入队伍</span></div>
                </div>
                <div class="share-panel">
                    <div class="share-box btn-active" @click="shareWeb(0x1)">
                        <img src="~assets/teamDraw/icon-wechat.png" alt="">
                        微信
                    </div>
                    <div class="share-box btn-active" @click="shareWeb(0x2)">
                        <img src="~assets/teamDraw/icon-circle.png" alt="">
                        朋友圈
                    </div>
                    <div class="share-box btn-active" @click="shareWeb(0x3)">
                        <img src="~assets/teamDraw/icon-qq.png" alt="">
                        QQ
                    </div>
                    <div class="share-box btn-active" @click="shareWeb(0x4)">
                        <img src="~assets/teamDraw/icon-zone.png" alt="">
                        QQ空间
                    </div>
                </div>
            </div>
            <div class="real-content" v-show="maskType === 'failMessage'">
                <div class="model-title">温馨提示</div>
                <div class="model-text">{{ message }}</div>
                <img class="btn-join" @click="closeMask" src="~assets/teamDraw/btn-know.png" alt="">
            </div>
        </div>
        <div class="fail-frame" v-show="maskType === 'fail'">
            <div class="model-title">很遗憾！</div>
            <img class="icon-box" src="~assets/teamDraw/icon-box.png" alt="">
            <div class="model-text" style="text-align:center">盒子里什么都没有，下次更好运哦！</div>
            <img class="btn-join" @click="closeMask" src="~assets/teamDraw/btn-know.png" alt="">
        </div>
        <!-- <van-number-keyboard
        :show="show"
        @blur="show = false"
        @input="onInput"
        @delete="onDelete"
        style="padding-bottom:0"
        /> -->
    </div>
</template>

<script>
import Vue from 'vue';
import { NumberKeyboard, Popup } from 'vant';
import primaryApi from "@/utils/primaryApi";
import Clipboard from 'clipboard'
Vue.use(NumberKeyboard, );
import { mapState } from "vuex";
export default {
  props:['maskType'],
  components: {

  },
  computed: {
    ...mapState([
      "uuid"
    ]),
  },
  data() {
    return {
        show:false,
        message:'',
        teamCode:'',
        autoInput:false,
        successCode:''
    }
  },
  mounted(){

  },
  methods:{
    shareWeb(type){
      this.$emit('shareWeb',type,'event_active_bt_success_share_click')
    },
    getTeamSkinTeamCreate(){
        this.$emit('getTeamSkinTeamCreate','popup')
    },
    closeMask(){
        if(this.maskType === 'fail'){
            this.$tea('event_active_box_result_page_close', { 'activityId': this.activityId});//加入队伍成功	
        }
        this.$emit('closeMask')
    },
    teamSkinTeamJoin(){
        this.$emit('teamSkinTeamJoin',this.teamCode)
    },
    // 复制队伍码
    copyGiftCode(code) {
        if (primaryApi.isSource) { // 判断运行环境是否233
            primaryApi.writeClipBoard(code); // 233app内复制邀请码到剪切板
            this.$toast('已复制到剪切板');
        } else {
            let clipboard = new Clipboard('.copyName', {
                text: function () {
                    return code
                }
            });
            clipboard.on('success', e => {
                this.$toast('已复制到剪切板');
                // 释放内存
                clipboard.destroy();
            });
            clipboard.on('error', e => {
                this.$toast('复制失败');
                clipboard.destroy();
            });
        }
    },
  }
}
</script>

<style scoped>
    .btn-active:active{
        transform: scale(0.9);
    }
    .mask{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(17,26,53,0.85);
        z-index: 1;
    }
    .mask-container{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
    }
    .frame{
        position: absolute;
        top: 2rem;
        width: 3.41rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
    .in-circle{
        width: 8px;
        height: 8px;
        position: absolute;
        /* background: rgba(31,44,75); */
    }
    .border-upright{
        background: RGBA(19, 17, 53, 1);
        border-right: 1px solid #EFCE6D;
        border-left: 1px solid #EFCE6D;
        width: 100%;
        height: calc(100% - 16px);
        position: absolute;
        left: 0;
        top: 8px;
    }
    .border-across{
        background: RGBA(19, 17, 53, 1);
        border-top: 1px solid #EFCE6D;
        border-bottom: 1px solid #EFCE6D;
        width: calc(100% - 16px);
        height: 100%;
        position: absolute;
        left: 8px;
        top: 0;
    }
    .in-top{
        left: 0;
        top: 0;
        border-right: solid 1px #EFCE6D;
        border-bottom: solid 1px #EFCE6D;
        border-radius: 0 0 8px 0;
    }
    .in-right{
        right: 0;
        top: 0;
        border-left: solid 1px #EFCE6D;
        border-bottom: solid 1px #EFCE6D;
        border-radius: 0 0 0 8px;
    }
    .in-bottom{
        right: 0;
        bottom: 0;
        border-left: solid 1px #EFCE6D;
        border-top: solid 1px #EFCE6D;
        border-radius: 8px 0 0 0;
    }
    .in-left{
        left: 0;
        bottom: 0;
        border-right: solid 1px #EFCE6D;
        border-top: solid 1px #EFCE6D;
        border-radius: 0 8px 0 0;
    }
    .model-title{
        width: 100%;
        font-weight: bold;
        color: #131135;
        background: linear-gradient(0deg, #FAF7B0 0%, #EFB858 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        padding: 0.17rem 0 0.23rem 0;
        font-size: 0.22rem;
        letter-spacing: 0.1em;
    }
    .real-content{
        position: relative;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 12;
        padding: 0 0.2rem;
    }
    .custom-input{
        width: 2.92rem;
        height: 0.36rem;
        margin: 0 auto;
        border: solid 1px #EFCE6D;
        position: relative;
        color: #EFCE6D;
        padding: 0.06rem 0.1rem;
        background: none;
    }
    .cursor{
        position: relative;
        line-height: 0.24rem;
        display: inline-block;
        height: 0.24rem;
    }
    .cursor::after{
        content: "";
        width: 1px;
        height: 0.16rem;
        background: #EFCE6D;
        position: absolute;
        right: -0.06rem;
        top: 0.04rem;
        animation: showOrHide 1.2s linear infinite;
    }
    @keyframes showOrHide {
        0% {
            opacity: 1;
        }
        50%{
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .auto-input-tip{
        width: 2.92rem;
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.16rem;
        color: #8FE8D3;
        margin: 0 auto;
    }
    .auto-input-tip span{
        width: 200%;
        display: block;
        transform: scale(0.5) translateX(-50%);
    }
    .btn-join{
        width: 1.56rem;
        height: 0.32rem;
        margin: 0.36rem auto 0.2rem auto;
        display: block;
    }
    .auto-input-desc{
        position: absolute;
        width: 100%;
        text-align: center;
        top: -0.26rem;
        color: white;
        font-size: 0.12rem;
    }
    .btn-join:active{
        transform: scale(0.9);
    }
    .model-text{
        color: #E6E6E6;
        font-size: 0.13rem;
    }
    .fail-frame{
        width: 100%;
        position: absolute;
        top: 1.8rem;
        z-index: 10;
    }
    .icon-box{
        width: 0.93rem;
        height: 0.99rem;
        margin: 0.05rem auto 0.23rem auto;
        display: block;
    }
    .team-code{
        text-align: center;
        color: #8FE8D3;
        font-size: 0.15rem;
        margin-bottom: 0.26rem;
    }
    .team-code span{
        display: inline-block;
        padding: 0 .2rem;
        position: relative;
        transform: translateX(-0.15rem);
    }
    .team-code span img{
        width: 0.15rem;
        height: 0.18rem;
        right: -0.15rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .team-code span img:active{
        transform: translateY(-50%) scale(0.9);
    }
    .out-line-box{
        width: 100%;
        height: 0.2rem;
        padding: 0 0.6rem;
        margin-bottom: 0.3rem;
        position: relative;
    }
    .in-line-box{
        text-align: center;
        font-size: 0.24rem;
        color: #D2B666;
        line-height: 0.48rem;
        position: relative;
    }
    .in-line-box span{
        width: 200%;
        display: inline-block;
        transform: scale(0.5) translate(-50%,-42%);
    }
    .share-panel{
        width: 100%;
        height: 0.75rem;
        margin-bottom: 0.3rem;
        display: flex;
        justify-content: space-between;
    }
    .share-box{
        width: 0.48rem;
        height: 0.72rem;
        text-align: center;
        color: white;
        font-size: 0.12rem;
    }
    .line{
        position: absolute;
        width: 3.4rem;
        height: 0.22rem;
        left: -0.2rem;
        top: 0;
    }
    .share-box img{
        width: 0.48rem;
        height: 0.48rem;
        display: block;
        margin-bottom: 0.08rem;
    }
    .icon-close{
        width: 0.14rem;
        height: 0.14rem;
        position: absolute;
        right: 0.17rem;
        top: 0.13rem;
    }
</style>
